import {handleActions} from 'redux-actions';
import * as actionTypes from './cuentas-actions';
import {handleApiAction} from '../services/ApiMiddleware.reducer';
import {flattenCuentas} from "./cuentas";

const initialState = {
    data: [],
    loadingCuentas: false,
    cuentasError: false,
};

export default handleActions({
    ...handleApiAction(actionTypes.getCuentas, {loadingField: 'loadingCuentas', errorField: 'cuentasError'},
        (state, {payload: {data = []}}) => {
            return {
                ...state,
                data: flattenCuentas(data)
            };
        }),
    ...handleApiAction(actionTypes.postCuentaDebitoAu, {loadingField: 'loadingCuentas', errorField: 'cuentasError'},
        (state, {payload: {data = []}}) => {
            return {
                ...state,
            };
        }),
    ...handleApiAction(actionTypes.postFacturaElectronica, {loadingField: 'loadingCuentas', errorField: 'cuentasError'},
        (state, {payload: {data = []}}) => {
            return {
                ...state,
            };
        }),
    ...handleApiAction(actionTypes.deleteFacturaElectronica, {loadingField: 'loadingCuentas', errorField: 'cuentasError'},
        (state, {payload: {data = []}}) => {
            return {
                ...state
            };
        }),
}, initialState);
